//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import RbBanner from '@/elements/editorial/rb-banner/rb-banner.vue'
import { MOBILE } from '@/scripts/constants/media-query'

export default {
  name: 'rb-slider-item',
  components: {
    RbBanner,
  },
  props: {
    isBlurred: {
      type: Boolean,
      default: false,
    },
    fixedHeight: undefined,
  },
  computed: {
    isCopyExternal() {
      return !this.isBlurred || (this.isBlurred && [MOBILE].includes(this.$mq))
    },
  },
}
